export default class RocketView
{
	id = null
	ownerId = null
	createdOn = null
	name = null
	buildType = null
	diameter = null
	length = null
	cp = null
	mass = null
	notes = null
	photoUrl = null

	flights = []

	get locked()
	{
		return this.flights.find(f => f.locked) != null;
	}

	get latestFlight()
	{
		let latestFlight = null;
		for(let flight of this.flights)
		{
			if(!latestFlight || flight.flownOn > latestFlight.flownOn)
				latestFlight = flight;
		}
		return latestFlight;
	}

	get hasMAPFlights()
	{
		return this.flights.filter(f => f.mapFlight).length > 0
	}
	get hasCertFlights()
	{
		return this.flights.filter(f => f.certFlight).length > 0
	}
	get hasRecordFlights()
	{
		return this.flights.filter(f => f.recordAttempt).length > 0
	}

	getFlight(flightId)
	{
		return this.flights.find(f => f.id == flightId)
	}

	deleteFlight(flightId)
	{
		this.flights.splice(this.flights.findIndex(f => f.id == flightId), 1)
	}

	lockFlight(flightId)
	{
		let flight = this.getFlight(flightId);
		flight.locked = true;
	}

	static Flight = class {
		id = null
		locked = false

		name = null
		flownOn = null
		location = null
		latitude = null
		longitude = null
		motors = []
		ejections = null
		mass = null
		sm = null
		notes = null
		predictedAlt = null
		logs = []

		outcome = null
		landingLatitude = null
		landingLongitude = null

		mapFlight = false
		mapTasks = []
		mapStatus = null
		mapReason = null

		certFlight = false
		certType = null
		certStatus = null
		certReason = null

		flightCardUrl = null

		recordAttempt = false
		altimeter = null
		teamName = null
		recordType = null
		recordClass = null
		reachedAlt = null
		recordStatus = null
		recordReason = null
		witness = null
	}
}